import { render } from "./SimpleModal.vue?vue&type=template&id=d955ef40&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=d955ef40&scoped=true&lang=css"

import exportComponent from "D:\\project\\lm-pgac\\PGAC-source\\pgac-600090-ob-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d955ef40"]])

export default __exports__